import React from 'react';

const RecentSalesTable = ({ sales = [] }) => {
    const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '-';
    const formatRM = (val) => `RM ${(val || 0).toLocaleString('en-MY', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

    return (
        <div style={{ background: 'white', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
            <h3 style={{ margin: '0 0 14px', fontSize: 14, fontWeight: 700 }}>New Sales — All Teams</h3>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 480 }}>
                <thead>
                    <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                        <th style={{ color: '#94A3B8', fontSize: 10, fontWeight: 600, textAlign: 'left', padding: '8px', letterSpacing: 0.5 }}>DEPOSIT DATE</th>
                        <th style={{ color: '#94A3B8', fontSize: 10, fontWeight: 600, textAlign: 'left', padding: '8px', letterSpacing: 0.5 }}>AGENT</th>
                        <th style={{ color: '#94A3B8', fontSize: 10, fontWeight: 600, textAlign: 'left', padding: '8px', letterSpacing: 0.5 }}>GROUP</th>
                        <th style={{ color: '#94A3B8', fontSize: 10, fontWeight: 600, textAlign: 'left', padding: '8px', letterSpacing: 0.5 }}>KWP</th>
                        <th style={{ color: '#94A3B8', fontSize: 10, fontWeight: 600, textAlign: 'left', padding: '8px', letterSpacing: 0.5 }}>PRICE</th>
                        <th style={{ color: '#94A3B8', fontSize: 10, fontWeight: 600, textAlign: 'left', padding: '8px', letterSpacing: 0.5 }}>STATE</th>
                    </tr>
                </thead>
                <tbody>
                    {sales.length === 0 ? (
                        <tr><td colSpan={6} style={{ textAlign: 'center', padding: 24, color: '#94A3B8' }}>No recent sales</td></tr>
                    ) : sales.map((s, i) => (
                        <tr key={s.salesId || i} style={{ borderBottom: i < sales.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                            <td style={{ fontSize: 12, padding: '10px 8px', color: '#64748B' }}>{formatDate(s.depositDate || s.depositOn)}</td>
                            <td style={{ fontSize: 12, padding: '10px 8px', fontWeight: 500 }}>{s.agentName}</td>
                            <td style={{ fontSize: 12, padding: '10px 8px', color: '#94A3B8' }}>{s.groupName || '-'}</td>
                            <td style={{ fontSize: 12, padding: '10px 8px', textAlign: 'left' }}>{s.energy || '-'}</td>
                            <td style={{ fontSize: 12, padding: '10px 8px', textAlign: 'left', color: '#10B981', fontWeight: 600 }}>{formatRM(s.finalPrice)}</td>
                            <td style={{ fontSize: 12, padding: '10px 8px', color: '#64748B' }}>{s.state || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
        </div>
    );
};

export default RecentSalesTable;
